import { render, staticRenderFns } from "./DeleteQuestionConfirmationDialog.vue?vue&type=template&id=3497940e"
import script from "./DeleteQuestionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQuestionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3497940e')) {
      api.createRecord('3497940e', component.options)
    } else {
      api.reload('3497940e', component.options)
    }
    module.hot.accept("./DeleteQuestionConfirmationDialog.vue?vue&type=template&id=3497940e", function () {
      api.rerender('3497940e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/DeleteQuestionConfirmationDialog.vue"
export default component.exports